import React from "react";
import { Route, Routes } from "react-router-dom";
import NonAuthLayout from "../Layouts/NonAuthLayout";
import { publicRoutes } from "./allRoutes";

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map(
            (
              route: { path: string | undefined; component: any },
              idx: React.Key | null | undefined
            ) => (
              <Route
                path={route.path}
                element={<NonAuthLayout>{route.component}</NonAuthLayout>}
                key={idx}
                // exact={true}
              />
            )
          )}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
